import { sx } from '../../../lib/sx'
import type { Vals } from '../../../demo/vals'

export function ConsentRequest({ v }: { v: Vals }) {
  return (
    <div style={sx("position:absolute;inset:0;background:var(--bg-overlay);display:flex;flex-direction:column;justify-content:flex-end")}>
      <div style={sx("padding:28px 20px 34px;border-radius:28px 28px 54px 54px;background:var(--bg-secondary);box-shadow:var(--shadow-bottom-sheet);display:flex;flex-direction:column;gap:16px;animation:gpop 250ms var(--ease-out)")}>
        <span style={sx("width:56px;height:56px;border-radius:var(--radius-md);background:var(--bg-accent-subtle);display:flex;align-items:center;justify-content:center")}>
          <span style={sx("width:26px;height:26px;background:var(--text-accent);-webkit-mask:url(/assets/icons/bell.svg) center/contain no-repeat;mask:url(/assets/icons/bell.svg) center/contain no-repeat")} />
        </span>
        <span style={sx("font-size:var(--fs-4xl);font-weight:var(--fw-bold);letter-spacing:var(--ls-sm);line-height:32px")}>
          Let Michael see what this iPhone blocks?
        </span>
        <span style={sx("font-size:var(--fs-sm);line-height:20px;color:var(--text-secondary)")}>
          Michael manages your Group. He's asking this device to send him an alert when Threat Protection blocks something.
        </span>
        <div style={sx("display:flex;flex-direction:column;gap:8px")}>
          <div style={sx("display:flex;gap:10px;align-items:center;padding:12px 14px;border-radius:var(--radius-md);background:var(--bg-tertiary)")}>
            <span style={sx("width:18px;height:18px;flex:none;background:var(--text-success);-webkit-mask:url(/assets/icons/checkmark.svg) center/contain no-repeat;mask:url(/assets/icons/checkmark.svg) center/contain no-repeat")} />
            <span style={sx("font-size:var(--fs-xs);line-height:18px")}>
              He sees: identified or blocked threat type and time
            </span>
          </div>
          <div style={sx("display:flex;gap:10px;align-items:center;padding:12px 14px;border-radius:var(--radius-md);background:var(--bg-tertiary)")}>
            <span style={sx("width:18px;height:18px;flex:none;background:var(--text-critical);-webkit-mask:url(/assets/icons/close.svg) center/contain no-repeat;mask:url(/assets/icons/close.svg) center/contain no-repeat")} />
            <span style={sx("font-size:var(--fs-xs);line-height:18px")}>
              He never sees: identified or blocked sites, calls, messages, location or content
            </span>
          </div>
        </div>
        <div style={sx("display:flex;flex-direction:column;gap:8px;margin-top:4px")}>
          <button onClick={v.acceptDevice} style={sx("height:52px;border-radius:var(--radius-full);border:none;background:var(--bg-accent);color:#fff;font-family:inherit;font-size:var(--fs-md);font-weight:var(--fw-medium);cursor:pointer")}>
            Allow alerts
          </button>
          <button onClick={v.declineDevice} style={sx("height:44px;border-radius:var(--radius-full);border:none;background:transparent;color:var(--text-secondary);font-family:inherit;font-size:var(--fs-sm);cursor:pointer")}>
            Keep this private
          </button>
        </div>
      </div>
    </div>
  )
}
